import BasicInitializationService from "../../services/initialization/basicInitializationService";
import makeWidgetFor from "../../viewModels/makeWidgetFor";
import KioskViewModel from "../../viewModels/tradingPlaces/kioskViewModel";
import { registerWidget } from "../widget";

const KioskWidgetIdentifier = "edaz-kiosk";

registerWidget({
  component: makeWidgetFor(KioskWidgetIdentifier, [KioskViewModel], BasicInitializationService),
  configuration: {
    tagname: KioskWidgetIdentifier,
  },
});
